<template>
  <div :style="wrap_style" class="note_wrap" :class="wrap_class">
    <div class="note_content" :class="{ over_length: currentlength >= maxlength }" :style="note_content_style">
      <h4 class="secondary_title text-uppercase">
        {{ $t('cart.remarks') }}
        <i v-if="is_expand=='vogue_page'" @click="showNote" :class="show_note==true?'el-icon-close':'el-icon-edit-outline'" style="cursor: pointer;"></i>
      </h4>
      <textarea
        v-if="show_note"
        class="page_text_font"
        name="cart_note"
        v-model="note"
        :style="note_input_style"
        :maxlength="maxlength"
        @blur="post_cart_note"
      >
      </textarea>

      <div v-if="show_note" class="warning page_text_font">
        <span>{{ $t('cart.remarks_limit') }}</span>
        <p :class="{ hidden_length_tip: currentlength > 0 }">{{ currentlength }}/{{ maxlength }}</p>
      </div>
    </div>
  </div>
</template>
<script>
// import API from '../../API'
export default {
  props: {
    note_content_style: {
      default() {
        return {}
      },
    },
    wrap_class: {
      default: '',
    },
    wrap_style: {
      default() {
        return {}
      },
    },
    note_input_style: {
      default() {
        return {}
      },
    },
    maxlength: {
      default: 500,
    },
    cart_note: {
      default: '',
    },
    is_expand: {
      default: '',
    }
  },
  data() {
    return {
      note: '',
      show_note: '',
    }
  },
  beforeMount() {
    this.note = this.cart_note
    this.show_note = this.is_expand!='vogue_page'
  },
  methods: {
    async post_cart_note() {
      try {
        let res = await this.$axios.post(API.cart_note, { note: this.note })
        this.$store.dispatch('change_news_cart', res.data)
      } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
          this.$message.error(error.response.data.message)
        }
      }
    },
    showNote() {
      this.show_note = !this.show_note
      this.note = this.show_note?this.cart_note:''
    },
  },
  computed: {
    currentlength() {
      if (this.note) return this.note.length
      else return 0
    },
  },
  watch: {
    '$store.state.news_cart'(newV) {
      this.note = newV.cart_note
    },
  },
}
</script>
<style scoped lang='scss'>
.cart_note_page {
  position: absolute;
  left: 0;
  z-index: 9;
}
.note_wrap {
  max-width: 100%;
  .note_content {
    width: 100%;
    max-width: 100%;
    position: relative;
    & > h4 {
      width: 100%;
      font-size: 16px;
      text-align: left;
      line-height: 1;
      color: #333;
      margin: 20px 0 10px 0;
      // padding-bottom: 5px;
      max-width: 100% !important;
    }
    textarea {
      width: 100%;
      height: 120px;
      overflow-y: auto;
      resize: none;
      padding: 8px;
      font-size: 14px;
      border-radius: 3px;
      border: 1px solid #DDDDDD;
      color: #999999;
      max-width: 100% !important;
      background-color: transparent;
      outline: none;
      line-height: 20px;
    }
    .warning {
      color: #d9001b;
      text-align: left;
      padding-right: 65px;
      position: relative;
      line-height: 1.6;
      span {
        visibility: hidden;
      }
      p {
        margin: 0;
        color: #aaaabd;
        pointer-events: none;
        float: right;
        position: absolute;
        right: 12px;
        top: -35px;
      }
      .hidden_length_tip {
        display: none;
      }
    }
  }
  .over_length {
    textarea {
      border-color: #d9001b;
      outline: none;
    }
    .warning {
      span {
        visibility: visible;
      }
      p {
        color: #d9001b;
        top: -25px !important;
      }
    }
  }
}
@media screen and(max-width: 767px) {
  .cart_note_page {
    flex: 0 0 100%;
    position: relative;
    .note_content {
      width: 100%;
      margin: auto;
    }
  }
}
</style>